import React from "react";
import SAHeader from "../../../components/Compliance Certificates/SA 8000/SAHeader";
import SAInfoContainer from "../../../components/Compliance Certificates/SA 8000/SAInfoContainer";

const SA8000 = () => {
  return (
    <div>
      <SAHeader />
      <SAInfoContainer />
    </div>
  );
};

export default SA8000;
